import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { Job, JobListResponse } from '../models/job.model';

@Injectable({
  providedIn: 'root'
})
export class CareersService {
  private base = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getCompanyJobList(companyName?: string): Observable<Job[]> {
    const url = `${this.base}/GetCompanyJobList`;
    const body = { company_name: companyName || environment.companyName };
    return this.http.post<JobListResponse>(url, body).pipe(
      map(res => res?.data || []),
      catchError(err => {
        console.error('GetCompanyJobList error', err);
  // Return an empty list on error so UI can render immediately instead of waiting.
  return of([] as Job[]);
      })
    );
  }

  getJobById(id: number, companyName?: string): Observable<Job | null> {
    return this.getCompanyJobList(companyName).pipe(
      map(list => list.find(j => j.id === id) || null)
    );
  }

  submitJobApplication(applicationData: {
    firstname: string;
    lastname: string;
    email: string;
    mobile: string;
    resume?: File | null;
    job_code: string | number; // Accept both
    company: string;
  }): Observable<any> {
    const url = `${this.base}/SubmitJobApplied`;
    
    // Try FormData first (for file upload)
    if (applicationData.resume) {
      const formData = new FormData();
      formData.append('firstname', applicationData.firstname);
      formData.append('lastname', applicationData.lastname);
      formData.append('email', applicationData.email);
      formData.append('mobile', applicationData.mobile);
      formData.append('resume', applicationData.resume, applicationData.resume.name);
      formData.append('job_code', String(applicationData.job_code));
      formData.append('company', applicationData.company);
      
      // Debug: Log the FormData contents
      console.log('FormData being sent:');
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }
      
      return this.http.post(url, formData, {
        headers: {
          // Don't set Content-Type for FormData - let browser set it with boundary
        }
      }).pipe(
        catchError(err => {
          console.error('API Error Details:', {
            status: err.status,
            statusText: err.statusText,
            error: err.error,
            message: err.message,
            url: url
          });
          throw err;
        })
      );
    } else {
      // If no file, try JSON format
      const jsonData = {
        firstname: applicationData.firstname,
        lastname: applicationData.lastname,
        email: applicationData.email,
        mobile: applicationData.mobile,
        job_code: String(applicationData.job_code),
        company: applicationData.company
      };
      
      console.log('JSON data being sent:', jsonData);
      
      return this.http.post(url, jsonData, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).pipe(
        catchError(err => {
          console.error('API Error Details:', {
            status: err.status,
            statusText: err.statusText,
            error: err.error,
            message: err.message,
            url: url
          });
          throw err;
        })
      );
    }
  }
}
